<template>
  <div>
    <HelpTip v-bind="labelInfo"></HelpTip>
    <TempDateTimePicker
      :formData="formData[id]"
      id="time"
      :customKey="{ type: 'date' }"
      :required="itemQequired"
      :placeholder="languages.smartOrderSelectStoreTime"
    ></TempDateTimePicker>
    <div v-for="(order, index) in formData[id]['orderList']" :key="order.id">
      <div class="order-type-content">
        <TempSelect
          class="order-type-content-select"
          :formData="formData[id]['orderList'][index]"
          id="channel"
          :customKey="channelCustomKey"
        ></TempSelect>
        <TempInput
          class="order-type-content-input"
          :formData="formData[id]['orderList'][index]"
          id="orderId"
          :required="itemQequired"
          label=""
          :placeholder="languages.smartOrderInputOrder"
        ></TempInput>
      </div>
      <TempInput
        :formData="formData[id]['orderList'][index]"
        id="amount"
        :required="itemQequired"
        label=""
        :placeholder="languages.smartOrderInputPrice"
      ></TempInput>
      <div class="order-btn">
        <span
          class="order-btn-item"
          @click="addOrder(index)"
          v-if="formData[id]['orderList'].length <= 5"
          >{{ languages.newAdd }}+</span
        >
        <span
          class="order-btn-item"
          v-if="formData[id]['orderList'].length > 1"
          @click="deleteOrder(index)"
          >{{ languages.smartDelete }}-</span
        >
      </div>
    </div>

    <TempUpload
      :formData="formData[id]"
      id="image"
      class="upload"
      :required="itemQequired"
      label=""
    ></TempUpload>
    <van-field
      v-show="false"
      class="input work-temp-form-item"
      name="check"
      :clearable="true"
      :rules="[
        { validator, required: true, message: languages.smartOrderAtlestChoose }
      ]"
      value="check"
    >
    </van-field>
    <div class="validator-tip" v-if="showValidatorTip">
      {{ languages.smartOrderAtlestChoose }}
    </div>
  </div>
</template>

<script>
import workTemp from '@mixins/officialSupport/workTemp';
import TempInput from '@components/officialSupport/workTemp/TempInput.vue';
import TempDateTimePicker from '@components/officialSupport/workTemp/TempDateTimePicker.vue';
import TempUpload from '@components/officialSupport/workTemp/TempUpload.vue';
import TempSelect from '@components/officialSupport/workTemp/TempSelect.vue';
import { nanoid } from 'nanoid';

const channel = {
  gp: 'Google Play',
  apple: 'App Store',
  official: 'Official Top-up'
};
export default {
  name: 'TempOrder',
  mixins: [workTemp],
  data() {
    return {
      itemQequired: false,
      showValidatorTip: false,
      channelCustomKey: {
        defaultValue: channel.gp,
        options: [
          {
            label: channel.gp,
            value: channel.gp
          },
          {
            label: channel.apple,
            value: channel.apple
          },
          {
            label: channel.official,
            value: channel.official
          }
        ]
      }
    };
  },
  created() {
    if (this.required) {
      this.itemQequired = this.required;
    }
    this.$set(this.formData[this.id], 'time', null);
    this.$set(this.formData[this.id], 'orderList', [
      { orderId: null, amount: null, channel: channel.gp, id: nanoid(25) }
    ]);
    this.$set(this.formData[this.id], 'image', null);
    this.$set(this.formData[this.id], 'check', null);
  },
  methods: {
    validator() {
      if (!this.itemQequired) {
        this.showValidatorTip = false;
        return true;
      }
      // 至少填写了一项就通过
      // order是否全都没填
      const orderAllEmpty = this.formData[this.id]['orderList'].every(
        item => !item.orderId && !item.amount
      );
      if (
        !this.formData[this.id].time &&
        (!this.formData[this.id].image.pic ||
          this.formData[this.id].image.pic == '[]') &&
        orderAllEmpty
      ) {
        this.showValidatorTip = true;
        return false;
      } else {
        this.showValidatorTip = false;
        return true;
      }
    },
    addOrder(index) {
      this.formData[this.id]['orderList'].splice(index + 1, 0, {
        orderId: null,
        amount: null,
        channel: channel.gp,
        id: nanoid(25)
      });
    },
    deleteOrder(index) {
      this.formData[this.id]['orderList'].splice(index, 1);
    }
  },
  components: {
    TempInput,
    TempDateTimePicker,
    TempUpload,
    TempSelect
  }
};
</script>

<style lang="scss" scoped>
.validator-tip {
  font-size: 16px;
  color: #ee0a24;
  text-align: left;
  margin-bottom: 15px;
}
.order-type-content {
  display: flex;
  &-select {
    width: 40%;
    margin-right: 10px;
  }
  &-input {
    width: 60%;
  }
}
.order-btn {
  color: var(--main-color);
  margin-bottom: 15px;
  &-item {
    margin-right: 20px;
    font-size: 16px;
  }
}
</style>
